// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".discussion-branch+.discussion-branch[data-v-344fccc8]{border-top:1px solid rgb(var(--foxy-border)/.7);padding-top:1.25rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
